<template>
  <div>
    <md-button class="md-accent md-dense md-raised download-button" @click="$store.dispatch('getExport', 'employees')">
      Preuzmi
    </md-button>
    <md-table v-if="$store.state.pageLoaded" class="small-table">
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <md-button class="md-icon-button md-raised md-accent" v-on:click="editCreateDialogVisible = true; createDialog = true; $store.state.selectedObject = JSON.parse(JSON.stringify(emptyEmployee))" title="Dodaj zaposlenika"  v-if="$store.state.schema.employee.create">
            <md-icon>add</md-icon>
          </md-button>
          <h1 class="md-title">Zaposlenici</h1>
        </div>
        <md-field md-clearable class="md-toolbar-section-end search-field">
          <md-icon>search</md-icon>
          <md-input placeholder="Pretraži..." v-model="searchKey"/>
        </md-field>
      </md-table-toolbar>

      <md-table-row v-if="$store.state.receivedData.employees.list.length > 0">
        <md-table-head>Ime i prezime</md-table-head>
        <md-table-head>Radno mjesto</md-table-head>
        <md-table-head>Raspoloživo karata</md-table-head>
        <md-table-head>Iskorištenih karata</md-table-head>
        <md-table-head class="t-align-center">Akcije</md-table-head>
      </md-table-row>

      <md-table-row md-selectable="single" md-auto-select v-for="item in $store.state.receivedData.employees.list" v-on:click="$store.state.selectedObject = JSON.parse(JSON.stringify(item))">
        <md-table-cell>{{ item.first_name }} {{ item.last_name }}</md-table-cell>
        <md-table-cell>{{ item.work_place_title }}</md-table-cell>
        <md-table-cell>{{ parseInt(item.available_tickets) - parseInt(item.used_tickets) }}</md-table-cell>
        <md-table-cell>{{ item.used_tickets }}</md-table-cell>
        <md-table-cell class="actions-cell">
          <md-button class="md-icon-button md-accent" v-on:click="deleteDialog = true" title="Obriši"  v-if="$store.state.schema.employee.delete">
            <md-icon>delete</md-icon>
          </md-button>
          <md-button class="md-icon-button" v-on:click="editCreateDialogVisible = true; editDialog = true;" title="Uredi"  v-if="$store.state.schema.employee.update">
            <md-icon>edit</md-icon>
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>

    <md-dialog-confirm :md-active.sync="deleteDialog"
                md-title="Brisanje zaposlenika"
                md-content="Jeste li sigurni?"
                md-confirm-text="Obriši"
                md-cancel-text="Zatvori"
                v-on:md-confirm="deleteSelected"
                >
    </md-dialog-confirm>

    <md-dialog :md-active.sync="editCreateDialogVisible" v-if="$store.state.selectedObject !== undefined" class="md-scrollbar">
      <md-dialog-title>{{ getDialogTitle }}</md-dialog-title>
      <md-card>
        <md-card-content>
          <div class="md-layout">
            <md-field :class="messageClass('first_name', $store.state.selectedObject)">
              <label>Ime</label>
              <md-input v-model="$store.state.selectedObject.first_name"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('last_name', $store.state.selectedObject)">
              <label>Prezime</label>
              <md-input v-model="$store.state.selectedObject.last_name"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('available_tickets', $store.state.selectedObject)">
              <label>Raspoloživo karata</label>
              <md-input v-model="$store.state.selectedObject.available_tickets"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('work_place', $store.state.selectedObject)">
              <label>Radno mjesto</label>
              <md-select v-model="$store.state.selectedObject.work_place">
                <md-option v-for="workPlace in $store.state.receivedData.workPlaces.list" :value="workPlace.id">
                  {{ workPlace.title }}
                </md-option>
              </md-select>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
          </div>
          <md-dialog-actions>
            <md-button v-on:click="editCreateDialogVisible = false;">Zatvori</md-button>
            <md-button v-on:click="createOrUpdate" class="md-primary">Spremi</md-button>
          </md-dialog-actions>
        </md-card-content>
      </md-card>
    </md-dialog>
  </div>
</template>

<script>
import ListingMixin from '../../mixins/listing-mixin.js'
import SearchMixin from '../../mixins/search-mixin.js'

export default {
  name: 'Employees',
  data(){
    return {
      emptyEmployee: {
        first_name: '',
        last_name: '',
        work_place: '',
        available_tickets: 10,
        data: {}
      },
      timeout: null,
      requiredFields: ['first_name', 'last_name', 'work_place', 'available_tickets'],
    }
  },

  mixins: [ListingMixin('employees', 'zaposlenika'), SearchMixin('employees', true)],
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Employees.vue